(function () {
  if (window.slrEbookInstructionGridInitialized) return;
  window.slrEbookInstructionGridInitialized = true;
  function initGrid(section) {
    if (!section || section.dataset.eigInitialized === 'true') return;
    section.dataset.eigInitialized = 'true';

    var tiles = section.querySelectorAll('.eig-tile[data-hover="true"]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function closeOtherTiles(activeTile) {
      tiles.forEach(function (tile) {
        if (tile !== activeTile) {
          tile.classList.remove('is-active');
        }
      });
    }

    function toggleTile(tile) {
      if (!mobileQuery.matches) return;

      var isActive = tile.classList.contains('is-active');

      closeOtherTiles(tile);

      if (isActive) {
        tile.classList.remove('is-active');
      } else {
        tile.classList.add('is-active');
      }
    }

    function resetTiles() {
      tiles.forEach(function (tile) {
        tile.classList.remove('is-active');
      });
    }

    resetTiles();

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function (event) {
        if (!mobileQuery.matches) return;
        event.preventDefault();
        toggleTile(tile);
      });

      tile.addEventListener('touchend', function (event) {
        if (!mobileQuery.matches) return;
        event.preventDefault();
        toggleTile(tile);
      }, { passive: false });

      tile.addEventListener('keydown', function (event) {
        if (!mobileQuery.matches) return;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleTile(tile);
        }
      });
    });

    window.addEventListener('resize', function () {
      if (!mobileQuery.matches) {
        resetTiles();
      }
    });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', resetTiles);
      document.addEventListener('shopify:block:select', resetTiles);
      document.addEventListener('shopify:block:deselect', resetTiles);
    }

  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-ebook-instruction-grid]').forEach(initGrid); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();
